import * as tslib_1 from "tslib";
import { jsonArrayMember, jsonMember, jsonObject } from "typedjson";
/**
 * Класс метаданных для типа узла дерева.
 * Метаданные позволяют управлять внешним видом и операциями с узлами раздельно по типам!
 */
let DxNodeType = class DxNodeType {
    /**
     * Класс метаданных для типа узла дерева.
     * Метаданные позволяют управлять внешним видом и операциями с узлами раздельно по типам!
     */
    constructor() {
        /** Выделять ли лэйбл узла жирным. */
        this._useBoldFont = false;
        /** Поодерживает ли узел данного типа действие drag из режима drag-and-drop. */
        this._allowDrag = false;
        /** Поодерживает ли узел данного типа действие drop из режима drag-and-drop. */
        this._allowDrop = false;
        /** Массив допустимых для данного типа узла действий тулбара. */
        this._allowedActionTypes = [];
    }
    get hasIcon() {
        return !!this._icon;
    }
    get type() {
        return this._type;
    }
    set type(value) {
        this._type = value;
    }
    get icon() {
        return this._icon;
    }
    set icon(value) {
        this._icon = value;
    }
    get useBoldFont() {
        return this._useBoldFont;
    }
    set useBoldFont(value) {
        this._useBoldFont = value;
    }
    get allowDrag() {
        return this._allowDrag;
    }
    set allowDrag(value) {
        this._allowDrag = value;
    }
    get allowDrop() {
        return this._allowDrop;
    }
    set allowDrop(value) {
        this._allowDrop = value;
    }
    get allowedActionTypes() {
        return this._allowedActionTypes;
    }
    set allowedActionTypes(value) {
        this._allowedActionTypes = value;
    }
    get instantiationActionType() {
        return this._instantiationActionType;
    }
    set instantiationActionType(value) {
        this._instantiationActionType = value;
    }
};
tslib_1.__decorate([
    jsonMember({ name: "type", constructor: String, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", String)
], DxNodeType.prototype, "_type", void 0);
tslib_1.__decorate([
    jsonMember({ name: "icon", constructor: String, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", String)
], DxNodeType.prototype, "_icon", void 0);
tslib_1.__decorate([
    jsonMember({ name: "useBoldFont", constructor: Boolean, emitDefaultValue: true, isRequired: false }),
    tslib_1.__metadata("design:type", Boolean)
], DxNodeType.prototype, "_useBoldFont", void 0);
tslib_1.__decorate([
    jsonMember({ name: "allowDrag", constructor: Boolean, emitDefaultValue: true, isRequired: false }),
    tslib_1.__metadata("design:type", Boolean)
], DxNodeType.prototype, "_allowDrag", void 0);
tslib_1.__decorate([
    jsonMember({ name: "allowDrop", constructor: Boolean, emitDefaultValue: true, isRequired: false }),
    tslib_1.__metadata("design:type", Boolean)
], DxNodeType.prototype, "_allowDrop", void 0);
tslib_1.__decorate([
    jsonArrayMember(String, { name: "allowedActionTypes", emitDefaultValue: true, isRequired: false }),
    tslib_1.__metadata("design:type", Array)
], DxNodeType.prototype, "_allowedActionTypes", void 0);
tslib_1.__decorate([
    jsonMember({ name: "instantiationActionType", constructor: String, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", String)
], DxNodeType.prototype, "_instantiationActionType", void 0);
DxNodeType = tslib_1.__decorate([
    jsonObject
], DxNodeType);
export { DxNodeType };
